import ActionTypes from "../constants/action-types";

export const toggleTip = (payload) => ({
    type: ActionTypes.TOGGLE_TIP,
    payload,
});
export const setTipPostId = (payload) => ({
    type: ActionTypes.SET_TIP_POST_ID,
    payload,
});
export const setTipNextAction = (payload) => ({
    type: ActionTypes.SET_TIP_NEXT_ACTION,
    payload,
});
